export default "__VITE_ASSET__277611ec__"